const STANDARD_DISMISS = {
    duration: 3000,
    onScreen: true
}

export default STANDARD_DISMISS